"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class GaiaConversation extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'gaiaConversation';
        this._title = initParams.title;
        this._updatedAt = initParams.updated_at;
        this._createdAt = initParams.created_at;
    }
    set title(value) {
        console.error('Do not set objects this way');
    }
    setTitle(value) {
        return this.dataService.updateGaiaConversation(this.id, { title: value }, this);
    }
    get title() {
        return this._title;
    }
    set updatedAt(value) {
        console.error('Do not set objects this way');
    }
    setUpdatedAt(value) {
        return this.dataService.updateGaiaConversation(this.id, { updated_at: value }, this);
    }
    get updatedAt() {
        return this._updatedAt;
    }
    set createdAt(value) {
        console.error('Do not set objects this way');
    }
    setCreatedAt(value) {
        return this.dataService.updateGaiaConversation(this.id, { created_at: value }, this);
    }
    get createdAt() {
        return this._createdAt;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateGaiaConversation(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteGaiaConversation(this.id, this);
    }
}
exports.default = GaiaConversation;
//# sourceMappingURL=gaiaConversation.js.map